var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-flex items-end w-full min-h-[41px] relative input-container"},[_c('AtomTextarea',{attrs:{"theme":_vm.theme,"value":_vm.value},on:{"input":_vm.emit,"blur":function($event){return _vm.$emit('blur')}}}),_vm._v(" "),_c('AtomInputLabel',{attrs:{"id-for":_vm.id,"label":_vm.label,"theme":_vm.theme}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }